import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useStreamProvider } from "../../api/StreamProvider";
import { CameraPermissionsPrompt } from "./CameraPermissionsPrompt";
import { useVideoSyncMonitor } from "../../api/VideoSyncMonitor";
import CircularProgress from '@mui/material/CircularProgress';
import Switch from '@material-ui/core/Switch';
import IconButton from '@material-ui/core/IconButton';
import HdrAutoIcon from '@mui/icons-material/HdrAuto';
import { Paper, Typography } from "@mui/material";


import "../../styles/devices/mob_Home.css";
import "../../styles/devices/mob_VersusMachine.css";
import "../../styles/devices/mob_Hub.css";


export function RecorderVideo(props) {

  const { stream } = props

  const { t } = useTranslation("global")

  const [autoMirror, setAutoMirror ] = useState(true)
  const [isMirrored, setIsMirrored] = useState(true);


  const main_videoCanvasRef = useRef(null);
  // const [isLoop, setIsLoop] = useState(false)
  // const [isPlaying, setIsPlaying] = useState(false)
  
  const { 
    streamVideoWidthRef,
    streamVideoHeightRef,
    streamVideoOriginal,
    streamVideoOut, 
    streamMediaBlobUrl,
    setStreamMediaBlobUrl
  } = useStreamProvider();

  const {
      isPlayingRecorder,
      setIsPlayingRecorder,
      forceStartVideoRecorder,
      forceStopVideoRecorder,
      forceCurrentTimeVideoRecorder,
      isLoopVideoRecorder
  } = useVideoSyncMonitor();

  useEffect(() => {
    startVideo()
  }, [forceStartVideoRecorder])

  useEffect(() => {
    stopVideo()
  }, [forceStopVideoRecorder])


  useEffect(() => {
    main_videoCanvasRef.current.currentTime = forceCurrentTimeVideoRecorder
  }, [forceCurrentTimeVideoRecorder])

  const stopVideo = () => {
    console.log("🚀 ~ VIDEOSSSS ~ stopVideo:", stopVideo)
    if (main_videoCanvasRef.current) {
        main_videoCanvasRef.current.pause();
        main_videoCanvasRef.current.currentTime = 0;
    }
  }

  const startVideo = () => {
      console.log("🚀 ~ VIDEOSSSS ~ startVideo:", startVideo)
      if (main_videoCanvasRef.current) {
        main_videoCanvasRef.current.currentTime = 0;
        main_videoCanvasRef.current.play();
      }
  }
  
  const handleMirroring = (event) => {
    setIsMirrored(event.target.checked);
  };



  useEffect(() => {
    if (streamMediaBlobUrl === undefined || streamMediaBlobUrl === null) {
      main_videoCanvasRef.current.srcObject = stream;
      main_videoCanvasRef.current.src = null;
      if (autoMirror){
        setIsMirrored(true)
      }
    }else{
      main_videoCanvasRef.current.src = streamMediaBlobUrl;
      main_videoCanvasRef.current.srcObject = null;
      if (autoMirror){
        setIsMirrored(false)
      }
    }
  }, [stream, streamMediaBlobUrl]);

  useEffect(() => {
    if (autoMirror){
      if (streamMediaBlobUrl === undefined || streamMediaBlobUrl === null) {
        setIsMirrored(true)
      }else{
        setIsMirrored(false)
      }
    }
  }, [autoMirror]);

  useEffect(() => {
    console.log("🚀 ~ RecorderVideo ~ isLoopVideoRecorder:", isLoopVideoRecorder)
  }, [isLoopVideoRecorder]);
  


  return (

    <>
      <div style={{ display: stream === null ? 'none' : 'block' }}>
        <div style={{ position: 'relative' }}>
          <video 
            ref={main_videoCanvasRef} 
            id="video_SectionVideo" 
            loop={isLoopVideoRecorder}
            autoPlay
            muted 
            style={{ 
              width: '600px', 
              height: '600px', 
              objectFit: 'cover', 
              transform: isMirrored ? 'scaleX(-1)' : 'scaleX(1)'
            }}
            onPlaying={()=> setIsPlayingRecorder(true)}
            onEnded={() => setIsPlayingRecorder(false)}
            onPause={() => setIsPlayingRecorder(false)}
          />


          {/* <div style={{ position: 'absolute', top: 0, right: 0, opacity: 0.5, transition: 'opacity 0.3s', ':hover': { opacity: 1 } }}>
            
            <Switch
              checked={isMirrored}
              onChange={handleMirroring}
              name="mirroringSwitch"
              inputProps={{ 'aria-label': 'secondary checkbox' }}
            />
            <IconButton style={{marginRight: '10px', padding: '2px', backgroundColor: autoMirror ? 'red': 'white', color: autoMirror ? 'white': '', fontWeight: 'bold', borderRadius: '50%'}} onClick={() => setAutoMirror(!autoMirror)}> 
              <HdrAutoIcon/> 
            </IconButton>

          </div> */}

          
        </div>
      </div>
      <div style={{ display: stream === null ? 'block' : 'none' }}>
        <div style={{ 
          width: '600px', 
          height: '600px', 
          backgroundColor: 'white', 
          objectFit: 'cover', 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center', 
          alignItems: 'center' 
        }}>
          <CircularProgress size={'100px'}/>
          <Paper style={{ 
              marginTop: '20px', 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              height: '100px', 
              width: '60%', 
              backgroundColor: '#1976d2', 
              color: 'white', 
              borderRadius: '20px',
              border: '5px solid red' 
            }}>
            <Typography variant="h6">Webcam no detectada.</Typography>
          </Paper>
        </div>
        {/* <CameraPermissionsPrompt /> */}
      </div>
    </>          
            
    );
  }
